import { Component, OnInit, AfterViewInit, TemplateRef, ViewChild, Renderer2, ElementRef } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { NavService } from '../../services/nav.service';
import { SidebarRightService } from '../../services/sidebar-right.service';
import moment from 'moment-timezone';
import { element } from 'protractor';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Store, select, State } from '@ngrx/store';
import * as dateActions from "../../../ngrx/act.action";
import { browserRefresh } from 'src/app/app.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../modal/modal.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionButtonsComponent } from '../action-buttons/action-buttons.component';
import { CommonService } from 'src/app/services/common.service';
import { faBell, faArrowLeft, faWalking, faChartLine,faFile, faTablet, faTable , faArrowRight} from '@fortawesome/free-solid-svg-icons';

import { GlobalNotificationServices } from 'src/app/components/administration/global-notifications/global-notifications-services';
import { Location } from '@angular/common';
import { FullscreenService } from 'src/app/fullscreen.service';
import { ChartType } from 'ng-apexcharts';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [GlobalNotificationServices]
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @ViewChild('content') private modalRef: TemplateRef<any>;
  faBell = faBell;
  faArrowLeft = faArrowLeft;
  faArrowRight=faArrowRight
  closeResult = '';
  public browserRefresh: boolean;
  technology: any;
  mapList: any = []
  toggleClass = "fe fe-maximize";
  layoutSubscription: Subscription;
  public isCollapsed = true;
  displayActions = false;
  categories = [
    { id: 1, name: 'IT Projects' },
    { id: 2, name: 'Business Case' },
    { id: 3, name: 'Microsoft Project' },
    { id: 4, name: 'Risk Management' },
    { id: 5, name: 'Team Building' },
  ]
  datetimeRange: any;
  pageName: any = '';
  public tzNames: string[];
  public selectedTz: string;
  public utcDate: moment.Moment;
  public tzDate: moment.Moment;
  timeZoneValue: any;
  timeZone: any;
  mapListObj: any[] = [];
  mapSubscription: Subscription;
  subscription: Subscription;
  articles$: any;
  hideDaterange: boolean = false
  displayCustomizeChart: boolean = false;
  modal: any;
  full_name: string;
  user_id: string;
  kuzzle: any;
  notificationroom: any;
  currentUser: string;
  notifications: any;
  notificationCount = 0;
  deploymentList: any = [];
  themestyle = true;
  theme: any = 'light-theme';
  startegy: string;
  showBackButton = false;

  pageToRedirectionMap={"Active Test":[{name:"Walktest View", url:"/walktest-report", icon:faFile, classname:"text-secondary"},
                                       {name:"Walk Test Summary", url:"/walktest-summary", icon:faTable, classname:"text-warning"},
                                       {name:"Telemetry", url:"/telemetry", icon:faChartLine, classname:"text-info"},
                                      {name:"Assets", url:"/assets", icon:faTablet, classname:"text-success"}],
                        "Walk Test View":[{name:"Active Test", url:"/live-walk-test", icon:faWalking, classname:"text-warning"},
                                        {name:"Detailed Report", url:"/walktest-detailed-report", icon:faFile, classname:"text-success"},
                                       {name:"Telemetry", url:"/telemetry", icon:faChartLine, classname:"text-info"},
                                      {name:"Assets", url:"/assets", icon:faTablet, classname:"text-success"}],
                        Telemetry:[{name:"Active Test", url:"/live-walk-test", icon:faWalking, classname:"text-warning"},
                                       {name:"Walktest View", url:"/walktest-report", icon:faFile, classname:"text-secondary"},
                                      {name:"Assets", url:"/assets", icon:faTablet, classname:"text-success"}],
                        Assets:[
                          {name:"Telemetry", url:"/telemetry", icon:faChartLine, classname:"text-info"},
                          {name:"Active Test", url:"/live-walk-test", icon:faWalking, classname:"text-warning"},
                          {name:"Walktest View", url:"/walktest-report", icon:faFile, classname:"text-secondary"},
                                ],
                        "Walk Test Summary":[{name:"Active Test", url:"/live-walk-test", icon:faWalking, classname:"text-warning"},
                                       {name:"Walktest View", url:"/walktest-report", icon:faFile, classname:"text-secondary"},
                                      {name:"Detailed Report", url:"/walktest-detailed-report", icon:faFile, classname:"text-success"}],
                      "Detailed Report":[{name:"Active Test", url:"/live-walk-test", icon:faWalking, classname:"text-warning"},
                                          {name:"Walktest View", url:"/walktest-report", icon:faFile, classname:"text-secondary"},
                                        {name:"Walk Test Summary", url:"/walktest-summary", icon:faTable, classname:"text-warning"}]                        
                                    }
  public chartTypes = [
    { label: 'Area', value: 'area', icon: 'area_chart' },
    { label: 'Line', value: 'line', icon: 'stacked_line_chart' },
    // { label: 'Scatter', value: 'scatter', icon: 'scatter_plot' },
    // { label: 'Bar', value: 'bar', icon: 'bar_chart' }
  ]; // Use ChartType for type safety
  selectedChartType: ChartType = 'line'; // Default chart type
  showMarkers: boolean = false;
  markerSize: number = 3;
  strokeSize: number = 3;
  backupConfig: any = {};
  activeChartConfigModel: any;
  constructor(private activeRoute: ActivatedRoute, private store: Store<any>, private fullscreenService: FullscreenService,
    private renderer: Renderer2,
    private notificationService: GlobalNotificationServices,
    private modalService: NgbModal,
    private sidebarRightservice: SidebarRightService, private router: Router,
    private location: Location,
    public navServices: NavService, public authService: AuthService,
    public dialog: MatDialog, private commonServices: CommonService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log(this.location.getState()?.['isNavigatedfromTest'], "this.location.getState()?.['isNavigatedFromPage']")
        if (this.location.getState()?.['isNavigatedfromTest']) {
          this.showBackButton = true;
        } else {
          this.showBackButton = false;
        }
        if (event.url == '/assets') {
          this.displayActions = true;
          this.hideDaterange = true;
          this.displayCustomizeChart = false;

        }
        else if (event.url == '/live-walk-test'
          || event.url == '/mno-mapping'
          || event.url == '/walktest-report'
          || event.url == '/groups-manager'
          || event.url == '/users-manager'
          || event.url == '/live-walk-test/walktest-scheduler'
          || event.url == '/edge-locate-new'
          || event.url == '/globalCompCharts'
          || event.url == '/walktest-report-table' || event.url == '/device-upgrade-manager') {
          this.hideDaterange = true;
          this.displayCustomizeChart = false;

        } else if (event.url == '/dashboard') {
          this.displayCustomizeChart = true;
          this.hideDaterange = false;
        }
        else {
          this.displayActions = false;
          this.hideDaterange = false;
          this.displayCustomizeChart = false;

        }
      }
    });
    this.layoutSubscription = sidebarRightservice.changeEmitted.subscribe(
      direction => {
        const dir = direction.direction;
      }
    )
  }

  toggleTheme(theme) {
    this.theme = theme;
    localStorage.setItem("themeMode", this.theme)
    this.setTheme()
  }
  setTheme() {
    if (this.theme == 'dark-theme') {
      this.renderer.addClass(document.body, 'dark-theme');
      this.renderer.removeClass(document.body, 'light-theme');
    } else if (this.theme == 'light-theme') {
      this.renderer.removeClass(document.body, 'dark-theme');
      this.renderer.addClass(document.body, 'light-theme');
    }
  }
  ngOnInit(): void {

    this.theme = localStorage.getItem("themeMode")
    this.theme = this.theme ? this.theme : 'light-theme'
    if (this.theme) {
      this.setTheme();
    }
    this.kuzzle = this.commonServices.kuzzleHeader;
    this.kuzzle && this.kuzzle.connect();

    this.notificationroom && this.kuzzle.realtime.unsubscribe(this.notificationroom);
    this.full_name = localStorage.getItem('full_name');
    this.user_id = localStorage.getItem('user_id');

    this.startegy = localStorage.getItem('startegy');

    this.browserRefresh = browserRefresh;
    if (this.browserRefresh) {
    }
    // this.deployment
    this.selectedDeployment = localStorage.getItem('deploymentId');

    this.authService.pageName.subscribe(x => {
      this.pageName = x;
      if (this.pageName == 'Indoor Map' || this.pageName == 'Outdoor Map' || this.pageName == 'Composite Map' || this.pageName == 'Home' || this.pageName == 'IoA Dashboard' || this.pageName == 'KPI Composite Map') {

      }
    }
    );
    this.tzNames = moment.tz.names();
    this.timeZoneChanged(moment.tz.guess());

    this.fetchNotifications();
  }

  setFullScreenClass() {
    this.fullscreenService.openFullscreen('header');
  }
  redirect() {
    this.authService.getPageNameData('Change Password');
    this.router.navigate(["users-manager/change-password"])
  }

  navigateWithParams() {
    console.log(this.location.getState()?.['page']);
    if (this.location.getState()?.['page'] == 'WalkTest') {
      this.router.navigateByUrl('/live-walk-test', { state: { isNavigatedFromPage: true } })
    } else if (this.location.getState()?.['page'] == 'Telemetry') {
      this.router.navigateByUrl('/telemetry', { state: { isNavigatedFromPage: false } })
    }
  else if (this.location.getState()?.['page'] == 'Assets') {
    this.router.navigateByUrl('/assets', { state: { isNavigatedFromPage: false } })
  }

  }

  toggleSidebarNotification() {
    this.sidebarRightservice.emitSidebarNotifyChange(true);
  }
  navigateToPage(url:any){
        this.router.navigateByUrl(url, {
      // state: { id: 1, device: row.id, isNavigatedfromTest: true, page:"Assets" },
    });
  }

  toggleSidebarOpen() {
    this.navServices.isActiveMenu = false;
    if ((this.navServices.collapseSidebar = true)) {
      this.navServices.toggleSidebarVisibility(true)
      document.querySelector('.main-body').classList.add('sidenav-toggled');
    }
  }
  toggleSidebarClose() {
    this.navServices.isActiveMenu = true;
    // this.navServices.activateSideNav=false;
    this.navServices.toggleSidebarVisibility(false)
    if ((this.navServices.collapseSidebar = true)) {
      document.querySelector('.main-body').classList.remove('sidenav-toggled');
    }
  }



  ngAfterViewInit() {
    const sidemenu = document.querySelector('.app-sidebar');
    let ps = new PerfectScrollbar(sidemenu, { wheelPropagation: false });

    const chat = document.querySelectorAll('.chat-scroll');
    let ps1 = new PerfectScrollbar(chat[0], { wheelPropagation: false });
    let ps2 = new PerfectScrollbar(chat[1], { wheelPropagation: false });

    const notification = document.querySelectorAll('.Notification-scroll');
    let ps3 = new PerfectScrollbar(notification[0], { wheelPropagation: false });
    let ps4 = new PerfectScrollbar(notification[1], { wheelPropagation: false });

  }
  logOut() {
    localStorage.clear();
  }


  selectFloor(event) {
    const selectedObj = this.mapListObj.find(x => x.site_name == event);
    // this.store.dispatch(new dateActions.selectedSite(selectedObj));
    // this.authService.sendMapFIlter(event);
  }
  selectedDeployment: any;
  selectDeployment(ev) {
    localStorage.setItem('deploymentId', this.selectedDeployment);
  }
  getdateRange(value) {  // method for selecting Date picker 
    this.datetimeRange = value;
    this.updateTime();

  }
  public timeZoneChanged(timeZone: string): void {
    this.selectedTz = timeZone;

    this.updateTime();
  }
  private updateTime() { //format time based on timezone
    if (this.datetimeRange) {
      let obj = this.datetimeRange;
      obj.startDate = moment(new Date(this.datetimeRange ? this.datetimeRange.startDate : new Date()).getTime()).tz(this.selectedTz);
      obj.endDate = moment(new Date(this.datetimeRange ? this.datetimeRange.endDate : new Date()).getTime()).tz(this.selectedTz);
      obj.label = this.datetimeRange.label;
      this.authService.sendMessage(obj);
      // //console.log("timezone",obj.startDate,obj.endDate)
    } else {
      let date = new Date();
      let obj: any = {
        startDate: date.setMinutes(date.getMinutes() - 15),
        endDate: new Date()
      }
      obj.startDate = moment(new Date(obj.startDate).getTime()).tz(this.selectedTz);
      obj.endDate = moment(new Date().getTime()).tz(this.selectedTz);
      obj.label = this.datetimeRange?.label;
      this.authService.sendMessage(obj);
    }

  }

  openConfig() {

    const activeModal = this.modalService.open(this.modalRef, { ariaLabelledBy: 'modal-basic-title', modalDialogClass: "customModel_styles" }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  refresh() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  subscribeNotifications = async () => {

    return await this.kuzzle.realtime.subscribe(
      'gwdevice',
      'eventnotification',
      {
        equals: {
          event_type: "ALERT"
        }
      },
      (notification: any) => {
        //console.log(notification);
        this.notificationCount++
      }
    )
  }

  redirectToCnfogurationpage() {
    this.authService.sendSubmitNotification.next({ eventType: "ALERT" });
    this.router.navigate(["/global-notifications"])
  }
  fetchNotifications() {
    const filter = {
      "query": {
        "bool": {
          "must": []
        }
      }, "sort": { "_kuzzle_info.createdAt": "desc" }
    }



    filter['query']['bool']['must'].push({ "query_string": { "query": 'ALERT', "type": "phrase", "fields": ["event_type"] } })


    this.notificationService.getglobalNotifications(filter).subscribe((res: any) => {

      let notifications = res?.result?.hits?.filter((el) => el._source.read == false);
      this.notificationCount = notifications.length;
      this.notifications = notifications.slice(0, 5)
      //console.log(this.notifications);
    })
  }
  applyChartConfig(chartConfigModal) {
    this.backupConfig = this.getCurrentConfig(); // Commit changes
    this.activeChartConfigModel?.close();
    this.onChartTypeChange();
  }
  getCurrentConfig() {
    return {
      selectedChartType: this.selectedChartType,
      showMarkers: this.showMarkers,
      markerSize: this.markerSize,
      strokeSize: this.strokeSize
    };
  }
  onChartTypeChange(): void {
    this.authService.sendChartConfig(this.getCurrentConfig());
  }
  resetChart() {
    this.selectedChartType = 'line';  // Default chart type
    this.showMarkers = false;  // Default marker visibility
    this.markerSize = 0;  // Default marker size
    this.strokeSize = 2.4;  // Default stroke size
  }
  hasUnsavedChanges(): boolean {
    const current = this.getCurrentConfig();
    return JSON.stringify(current) !== JSON.stringify(this.backupConfig);
  }
  handleModalDismiss() {
    if (this.hasUnsavedChanges()) {
      if (confirm('You have unsaved changes. Do you want to discard them?')) {
        this.restoreBackupConfig();
        this.onChartTypeChange();
        this.activeChartConfigModel?.close();
      }
    } else {
      this.activeChartConfigModel?.close();
    }
  }

  restoreBackupConfig() {
    this.selectedChartType = this.backupConfig.selectedChartType;
    this.showMarkers = this.backupConfig.showMarkers;
    this.markerSize = this.backupConfig.markerSize;
    this.strokeSize = this.backupConfig.strokeSize;
  }
  openChartConfig(chartConfigModal) {
    this.backupConfig = this.getCurrentConfig();
    this.activeChartConfigModel = this.modalService.open(chartConfigModal, { backdrop: 'static' });
  }
} 
